import { API_BASE_URL, CHATBOT_URL } from 'config';
import { useTheme } from 'contexts/ThemeContext';
import { USER_TOKEN, USER_VIEW_MODE } from 'helpers/storage';
import { useEffect } from 'react';

const ChatbotModal = () => {
  const token = USER_TOKEN.get()?.replace('Bearer ', '').trim();
  const role = USER_VIEW_MODE.get();
  const backendUrl = API_BASE_URL;

  const { isDarkMode } = useTheme();
  const rawTheme = isDarkMode ? 'dark' : 'light';
  const theme = String(rawTheme).toLowerCase().trim() === 'dark' ? 'dark' : 'light';

  useEffect(() => {
    if (!token) return;

    // 1️⃣ Set global config FIRST
    window.ChatbotConfig = {
      chatbotUrl: CHATBOT_URL,
      token,
      origin: backendUrl,
      role,
      theme,
    };

    // 2️⃣ Prevent duplicate script load
    if (document.getElementById('mindchamps-chatbot')) return;

    // 3️⃣ Inject script
    const script = document.createElement('script');
    script.id = 'mindchamps-chatbot';
    script.src = `${CHATBOT_URL}/chatbot-widget.js`;
    script.async = true;

    document.body.appendChild(script);

    // 4️⃣ Cleanup (optional but recommended)
    return () => {
      script.remove();
      delete window.ChatbotConfig;
    };
  }, [token, backendUrl, role]);

  useEffect(() => {
    window.ChatbotConfig = {
      ...window.ChatbotConfig,
      theme,
    };

    const sendTheme = () => {
      const iframe = document.getElementById('mindchamps-chatbot-widget');
      if (iframe?.contentWindow) {
        iframe.contentWindow.postMessage(
          {
            type: 'theme',
            theme,
          },
          CHATBOT_URL,
        );
      }
    };

    // Try immediately (in case ready)
    sendTheme();

    // Also try after short delay in case iframe just mounted
    const t1 = setTimeout(sendTheme, 100);
    const t2 = setTimeout(sendTheme, 400);

    // Attach load listener if iframe exists
    const iframeEl = document.getElementById('mindchamps-chatbot-widget');
    if (iframeEl) {
      iframeEl.addEventListener('load', sendTheme, { once: true });
    }

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      if (iframeEl) {
        iframeEl.removeEventListener('load', sendTheme);
      }
    };
  }, [theme]);

  return null; // widget handles its own UI
};

export default ChatbotModal;
